import { createContext } from "react";

const PermitionDaysContext = createContext();

export default PermitionDaysContext;
